module.exports = __webpack_public_path__ + "static/media/MINISERIF-BOLD.f126d080.TTF";